import * as React from 'react';
import type { FormFields } from '../../../../../../utils/formUtils';
import type { DetailsEvnex } from '../types';
import { ConfirmationStepForm } from './ConfirmationStepForm';

const fields: FormFields<DetailsEvnex> = { serial: { id: 'serial', label: 'Serial' } };

export const ConfirmationStepEvnex: React.FC = () => <ConfirmationStepForm fields={fields} />;
